export default __webpack_public_path__ + "static/media/emp_ezy_logo.73dc053a.png";